import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close\"><defs><style>#icon-close .a{fill:currentColor;}</style></defs><path class=\"a\" d=\"M7,14a7,7,0,1,1,7-7,7,7,0,0,1-7,7ZM4.183,5.064,6.118,7,4.183,8.936a.623.623,0,1,0,.881.881L7,7.882,8.936,9.817a.623.623,0,1,0,.881-.881L7.882,7,9.817,5.064a.623.623,0,1,0-.881-.881L7,6.118,5.064,4.183a.623.623,0,1,0-.881.881Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol